module.exports = __webpack_public_path__ + "media/images/products/discovery-retailers-landing-zoomed-a9169607bb7e9baf5dd8db681b3b807a.jpg";